import type { IconProps } from "../types";

export const Trash2 = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M19 6v16H5V6" />
    <path d="M3 6h18" />
    <path d="M8 6V2h8v4" />
  </svg>
);
